import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import helmetConfig from './helmetConfig.json';

const HelmetWrapper = () => {
  const location = useLocation();
  const path = location.pathname;
  const config = helmetConfig[path] || {
    title: 'Your Brand Name',
    description: 'Default description for pages without specific SEO configuration.',
    robots: 'index, follow',
    canonical: `https://yourdomain.com${path}`,
    og: {
      title: 'Your Brand Name',
      description: 'Default description for pages without specific SEO configuration.',
      type: 'website',
      url: `https://yourdomain.com${path}`,
      image: 'https://yourdomain.com/assets/default-banner.jpg',
    },
    twitter: {
      card: 'summary_large_image',
      title: 'Your Brand Name',
      description: 'Default description for pages without specific SEO configuration.',
      image: 'https://yourdomain.com/assets/default-banner.jpg',
    },
  };

  return (
    <Helmet>
      <title>{config.title}</title>
      <meta name="description" content={config.description} />
      <meta name="robots" content={config.robots} />
      <link rel="canonical" href={config.canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={config.og.title} />
      <meta property="og:description" content={config.og.description} />
      <meta property="og:type" content={config.og.type} />
      <meta property="og:url" content={config.og.url} />
      <meta property="og:image" content={config.og.image} />

      {/* Twitter Card */}
      <meta name="twitter:card" content={config.twitter.card} />
      <meta name="twitter:title" content={config.twitter.title} />
      <meta name="twitter:description" content={config.twitter.description} />
      <meta name="twitter:image" content={config.twitter.image} />
    </Helmet>
  );
};

export default HelmetWrapper;